import React, { useState } from 'react';
import {
  FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock,
  FaLinkedin, FaTwitter, FaFacebook, FaInstagram,
  FaPaperPlane, FaCheckCircle
} from 'react-icons/fa';
import SEOHelmet from '../SEOHelmet';
import Navbar from './Navbar';
import '../../styles/landing-page/ContactPage.css';
import ctaimage1 from '../../assets/Mobileview.png';
import ctaimage2 from '../../assets/AdminDashboard2.png';
import { useNavigate } from 'react-router-dom';
import supportTeamImg from '../../assets/contactus.jpg';

const ContactPage = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('contact');
  const [expandedFAQ, setExpandedFAQ] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Simulate form submission
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        subject: '',
        message: ''
      });
      
      // Reset success message after 5 seconds
      setTimeout(() => setSubmitted(false), 5000);
    }, 1500);
  };

  const contactInfo = [
    {
      icon: FaMapMarkerAlt,
      title: 'Address',
      content: '123 Innovation Drive, Tech Park, San Francisco, CA 94105',
      color: '#001d3d'
    },
    {
      icon: FaPhone,
      title: 'Phone',
      content: '+1 (555) 123-4567',
      color: '#003d7a',
      link: 'tel:+15551234567'
    },
    {
      icon: FaEnvelope,
      title: 'Email',
      content: 'info@assetflows.in',
      color: '#FFD60A',
      link: 'mailto:info@assetflows.in'
    },
    {
      icon: FaClock,
      title: 'Business Hours',
      content: 'Mon - Fri: 9:00 AM - 6:00 PM EST',
      color: '#001d3d'
    }
  ];

  const faqItems = [
    {
      question: 'What is the typical implementation timeline?',
      answer: 'Most implementations are completed within 2-4 weeks, depending on your organization\'s complexity and data volume.'
    },
    {
      question: 'Do you offer training for our team?',
      answer: 'Yes! We provide comprehensive onboarding training and continuous support to ensure your team gets the most out of Assets Flow.'
    },
    {
      question: 'Can we integrate with our existing systems?',
      answer: 'Absolutely. Assets Flow integrates with most popular ERPs, CRMs, and enterprise systems through our robust API.'
    },
    {
      question: 'What kind of support do you provide?',
      answer: '24/7 technical support via email, phone, and chat. We also have a dedicated success manager for enterprise clients.'
    }
  ];

  const socialLinks = [
    { icon: FaLinkedin, url: 'https://linkedin.com', label: 'LinkedIn' },
    { icon: FaTwitter, url: 'https://twitter.com', label: 'Twitter' },
    { icon: FaFacebook, url: 'https://facebook.com', label: 'Facebook' },
    { icon: FaInstagram, url: 'https://instagram.com', label: 'Instagram' }
  ];

  return (
    <div className="contact-page">
      <SEOHelmet page="contact" canonicalUrl="https://www.assetflows.in/contact" />
      {/* Header */}
      <header className="contact-header">
        <Navbar activeSection={activeSection} setActiveSection={setActiveSection} />
        <div className="contact-header__content">
          <h1 className='heading-yellow'>Get in Touch With Us</h1>
          <p>Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
        </div>
        <div className="contact-header__image">
          <img src={supportTeamImg} alt="Support Team" />
        </div>
      </header>

      {/* Main Content */}
      <main className="contact-main">
        {/* Contact Info Cards */}
        <section className="contact-info-section">
          <div className="contact-container">
            <div className="contact-info-grid">
              {contactInfo.map((info, idx) => {
                const Icon = info.icon;
                return (
                  <div key={idx} className="contact-info-card">
                    <div className="info-icon" style={{ color: info.color }}>
                      <Icon size={32} />
                    </div>
                    <h3>{info.title}</h3>
                    {info.link ? (
                      <a href={info.link} className="info-content">
                        {info.content}
                      </a>
                    ) : (
                      <p className="info-content">{info.content}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Contact Form & Map */}
        <section className="contact-form-section">
          <div className="contact-container">
            <div className="form-map-grid">
              {/* Form */}
              <div className="contact-form-wrapper">
                <h2>Send us a Message</h2>
                {submitted ? (
                  <div className="success-message">
                    <FaCheckCircle size={48} />
                    <h3>Thank You!</h3>
                    <p>Your message has been sent successfully. We'll get back to you within 24 hours.</p>
                  </div>
                ) : (
                  <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="name">Full Name *</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                          placeholder="John Doe"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="email">Email Address *</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                          placeholder="john@example.com"
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="phone">Phone Number</label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          placeholder="+1 (555) 123-4567"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="company">Company</label>
                        <input
                          type="text"
                          id="company"
                          name="company"
                          value={formData.company}
                          onChange={handleInputChange}
                          placeholder="Your Company"
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label htmlFor="subject">Subject *</label>
                      <select
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Select a subject...</option>
                        <option value="sales">Sales Inquiry</option>
                        <option value="support">Support Request</option>
                        <option value="demo">Request a Demo</option>
                        <option value="partnership">Partnership</option>
                        <option value="other">Other</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="message">Message *</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                        placeholder="Tell us how we can help..."
                        rows="6"
                      />
                    </div>

                    <button
                      type="submit"
                      className="submit-btn"
                      disabled={loading}
                    >
                      {loading ? 'Sending...' : <>Send Message <FaPaperPlane style={{ marginLeft: '8px' }} /></>}
                    </button>
                  </form>
                )}
              </div>

              {/* Map Placeholder */}
              <div className="contact-map-wrapper">
                <div className="contact-map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.0198968165167!2d-122.41941592346972!3d37.77492957122017!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80858064c5a90f71%3A0x3e3d3b3b3b3b3b3b!2s123%20Innovation%20Drive%2C%20San%20Francisco%2C%20CA%2094105!5e0!3m2!1sen!2sus!4v1234567890"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Assets Flow Location"
                  />
                </div>
                <img src={supportTeamImg} alt="Support Team" className="map-overlay" />
                      {/* Add image below the map */}
                      <div className="contact-below-map-image-wrapper">
                        <img src={ctaimage2} alt="Contact Illustration" className="contact-below-map-image" />
                      </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="contact-faq-section contact-section-bg-white">
          <div className="contact-container">
            <h2 className="section-title">Frequently Asked Questions</h2>
            <div className="faq-accordion">
              {faqItems.map((item, idx) => (
                <div
                  key={idx}
                  className={`faq-item ${expandedFAQ === idx ? 'active' : ''}`}
                >
                  <button
                    className="faq-question"
                    onClick={() => setExpandedFAQ(expandedFAQ === idx ? null : idx)}
                    type="button"
                  >
                    <span>{item.question}</span>
                    <span className="faq-arrow" />
                  </button>
                  {expandedFAQ === idx && (
                    <div className="faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Social Links & CTA */}
        <section className="contact-social-section contact-section-bg-blue">
          <div className="contact-container">
            <h2>Connect With Us</h2>
            <div className="social-links">
              {socialLinks.map((social, idx) => {
                const Icon = social.icon;
                return (
                  <a
                    key={idx}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    title={social.label}
                  >
                    <Icon size={24} />
                  </a>
                );
              })}
            </div>
            <div className="social-cta">
              <p>Follow us for updates and industry insights</p>
            </div>
          </div>
        </section>
      </main>
      {/* CTA Section from PricingPage */}
      <section className="pricing-cta contact-section-bg-yellow">
        <div className="pricing-cta-content">
          <div className="pricing-cta-left">
            <h2>Ready to Transform Your Asset Management?</h2>
            <p>
              Start your 14-day free trial today. No credit card required. Join thousands of organizations 
              trusting AssetFlows with their most critical assets.
            </p>
            <button>Start Your Free Trial</button>
          </div>
          <div className="pricing-cta-right">
            <div className="cta-mockup-container">
              <div className="cta-mockup-mobile">
                <img src={ctaimage1} alt="Mobile View" />
              </div>
              <div className="cta-mockup-laptop">
                <img src={ctaimage2} alt="Laptop View" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER SECTION from PricingPage */}
      <footer className="pricing-footer contact-section-bg-light">
        <div className="footer-content">
          <div className="footer-grid">
            {/* Brand Section */}
            <div className="footer-section">
              <div className="footer-brand">
                <span>📦</span>
                <span>AssetFlows</span>
              </div>
              <p className="footer-description">
                The most comprehensive, user-friendly asset management platform trusted by 5,000+ organizations worldwide. 
                From startups to Fortune 500 companies, AssetFlows is the smart choice for intelligent asset management, 
                maintenance tracking, and operational excellence.
              </p>
              <div className="footer-social">
                <button onClick={() => {}} title="Facebook" className="icon-btn"><FaFacebook /></button>
                <button onClick={() => {}} title="Twitter" className="icon-btn"><FaTwitter /></button>
                <button onClick={() => {}} title="LinkedIn" className="icon-btn"><FaLinkedin /></button>
                <button onClick={() => {}} title="Instagram" className="icon-btn"><FaInstagram /></button>
              </div>
            </div>

            {/* Product Section */}
            <div className="footer-section">
              <h4>Product</h4>
              <ul>
                <li><a href="/pricing" onClick={() => navigate('/pricing')}>Pricing</a></li>
                <li><a href="/why-assetflow" onClick={() => navigate('/why-assetflow')}>Why AssetFlows</a></li>
                <li><span>Features</span></li>
                <li><span>Security</span></li>
                <li><span>Integrations</span></li>
              </ul>
            </div>

            {/* Company Section */}
            <div className="footer-section">
              <h4>Company</h4>
              <ul>
                <li><span>About Us</span></li>
                <li><span>Blog</span></li>
                <li><span>Careers</span></li>
                <li><span>Contact</span></li>
                <li><span>Partners</span></li>
              </ul>
            </div>

            {/* Resources Section */}
            <div className="footer-section">
              <h4>Resources</h4>
              <ul>
                <li><span>Documentation</span></li>
                <li><span>Support</span></li>
                <li><span>FAQ</span></li>
                <li><span>Community</span></li>
                <li><span>Status</span></li>
              </ul>
            </div>
          </div>

          {/* Divider */}
          <div className="footer-divider"></div>

          {/* Bottom Footer */}
          <div className="footer-bottom">
            <p>&copy; 2024 AssetFlows. All rights reserved.</p>
            <div className="footer-links">
              <button onClick={() => {}} className="footer-link-btn">Privacy Policy</button>
              <button onClick={() => {}} className="footer-link-btn">Terms of Service</button>
              <button onClick={() => {}} className="footer-link-btn">Cookie Policy</button>
              <button onClick={() => {}} className="footer-link-btn">Security</button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;
